import { PARCHI_GEN_OTP } from '../constants';
import fetchWithRefresh from '../fetchWithRefresh';

interface Body {
    mobile: string;
    health_id?: string;
    pid?: string;
}

interface Response {
    success: boolean;
    data: {
        skip_state: string;
        txn_id: string;
        error?: string;
        healthId?: string;
    };
    error?: string;
}

export const generateAbhaOtp = (
    docid: string,
    clinicid: string,
    businessId: string,
    body: Body,
): Promise<Response> => {
    return fetchWithRefresh(PARCHI_GEN_OTP, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            'client-id': 'doc-web-new',
            'doc-id': docid,
            'clinic-id': clinicid,
            'b-id': businessId,
        },
    }).then((res) => res.json());
};
